import {
  Button as ChordsButton,
  type ButtonSize,
  type ButtonVariant,
} from '~/chords/Button';

import { withClassNameHoc } from '../WithClassNameHoc';

export const Button = withClassNameHoc(ChordsButton);
export type { ButtonSize, ButtonVariant };
